// extracted by mini-css-extract-plugin
export default {"toolbar_action_button":"styles_toolbar_action_button__pZkZo"};